import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ForgotPassword from './pages/Auth/ForgotPassword/ForgotPassword';
import ForgotPasswordValidate from './pages/Auth/ForgotPasswordValidate/ForgotPasswordValidate';
import OtpValidation from './pages/Auth/OtpValidation/OtpValidation';
import Registration from './pages/Auth/Registration/Registration';
import UserLogin from './pages/Auth/UserLogin/UserLogin';
import Dashboard from './pages/Dashboard';
import EarnQRScan from './pages/EarnQRScan/EarnQRScan';
import ListBusinesses from './pages/ListBusinesses/ListBusinesses';
import PointsTransferHistory from './pages/PointsTransferHistory/PointsTransferHistory';
import QRScan from './pages/QRScan/QRScan';
import RewardsAndHistory from './pages/RewardsAndHistory/RewardsAndHistory';
import RewardsAndHistoryComment from './pages/RewardsAndHistoryComment/RewardsAndHistoryComment';
import ThankYou from './pages/ThankYou/ThankYou';
import UserProfileUpdate from './pages/UserProfileUpdate/UserProfileUpdate';
import PrivateRoute from './routes/PrivateRoute';

function App() {
    return (
        <Router>
            <main className="container-main">
                <ToastContainer />
                <Routes>
                    <Route path="*" element={<Navigate to='/' replace />} />
                    <Route path="/" element={<UserLogin />} />
                    <Route path="/login" element={<UserLogin />} />
                    <Route path="/pswd" element={<Navigate to="/registration" replace />} />
                    <Route path="/registration" element={<Registration />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route path="/forgot-password/otp" element={<OtpValidation />} />
                    <Route path="/forgot-password/validate" element={<ForgotPasswordValidate />} />
                    <Route path="/qr-scan/:transfer_history_token" element={<QRScan />} />
                    <Route path="/earn-qr-scan/:token" element={<EarnQRScan />} />
                    <Route path="/thank-you" element={<ThankYou />} />
                    <Route element={<PrivateRoute />}>
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/dashboard/profile-update" element={<UserProfileUpdate />} />
                        <Route path="/dashboard/businesses" element={<ListBusinesses />} />
                        <Route path="/dashboard/rewards-history" element={<RewardsAndHistory />} />
                        <Route path="/dashboard/rewards-history/comments/:history_token" element={<RewardsAndHistoryComment />} />
                        <Route path="/dashboard/points-transfer-history" element={<PointsTransferHistory />} />
                    </Route>
                </Routes>
            </main>
        </Router>
    );
}

export default App;